import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";
import { useEffectiveTenantId } from "./impersonation";

export function useTenantOcrConfig() {
  const tenantId = useEffectiveTenantId();
  const [config, setConfig] = useState<{
    identifiers: string[];
    taxIdHints: string[];
    knownProducts: string[];
    validPrices: number[];
    loading: boolean;
  }>({
    identifiers: [],
    taxIdHints: [],
    knownProducts: [],
    validPrices: [],
    loading: true
  });

  useEffect(() => {
    if (!tenantId) {
      setConfig((c) => ({ ...c, loading: false }));
      return;
    }
    return onSnapshot(
      doc(db, "tenants", tenantId, "config", "ocr"),
      (snap) => {
        const d = snap.data();
        setConfig({
          identifiers: (d?.identifiers as string[]) ?? [],
          taxIdHints: (d?.taxIdHints as string[]) ?? [],
          knownProducts: (d?.knownProducts as string[]) ?? [],
          validPrices: (d?.validPrices as number[]) ?? [],
          loading: false
        });
      },
      () => setConfig((c) => ({ ...c, loading: false }))
    );
  }, [tenantId]);

  return config;
}

export function useLoyaltyConfig() {
  const tenantId = useEffectiveTenantId();
  const [config, setConfig] = useState<{
    ticketsForReward: number;
    rewardLabel: string;
    rewardItem: string;
    loading: boolean;
  }>({
    ticketsForReward: 5,
    rewardLabel: "Reward gratis",
    rewardItem: "",
    loading: true
  });

  useEffect(() => {
    if (!tenantId) {
      setConfig((c) => ({ ...c, loading: false }));
      return;
    }
    return onSnapshot(
      doc(db, "tenants", tenantId, "config", "loyalty"),
      (snap) => {
        const d = snap.data();
        setConfig({
          ticketsForReward: (d?.ticketsForReward as number) ?? 5,
          rewardLabel: (d?.rewardLabel as string) ?? "Reward gratis",
          rewardItem: (d?.rewardItem as string) ?? "",
          loading: false
        });
      },
      () => setConfig((c) => ({ ...c, loading: false }))
    );
  }, [tenantId]);

  return config;
}
